const WIDGET_DEPLOY_CELEBRATION_WINDOW_MS = 4 * 60 * 60 * 1000;
const WIDGET_DEPLOY_CELEBRATION_STORAGE_PREFIX =
  "widget_deploy_celebration_seen";

const normalizeTimestampToUtc = (value: string): string => {
  const trimmedValue = value.trim();
  if (!trimmedValue) return "";

  const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(trimmedValue);
  return hasTimezone ? trimmedValue : `${trimmedValue}Z`;
};

const parseWidgetDeployedAt = (value?: string | null): number | null => {
  if (!value) return null;
  const timestamp = Date.parse(normalizeTimestampToUtc(value));
  if (Number.isNaN(timestamp)) return null;
  return timestamp;
};

const getStorageKey = (clinicId: string, deployedAtTimestamp: number): string =>
  `${WIDGET_DEPLOY_CELEBRATION_STORAGE_PREFIX}_${clinicId}_${deployedAtTimestamp}`;

export const shouldShowWidgetDeployCelebration = (params: {
  clinicId?: string | null;
  widgetDeployedAt?: string | null;
  now?: number;
}): boolean => {
  const { clinicId, widgetDeployedAt, now = Date.now() } = params;
  if (!clinicId || !widgetDeployedAt || typeof window === "undefined") {
    return false;
  }

  const deployedAtTimestamp = parseWidgetDeployedAt(widgetDeployedAt);
  if (!deployedAtTimestamp) return false;

  const ageMs = now - deployedAtTimestamp;
  if (ageMs < 0 || ageMs > WIDGET_DEPLOY_CELEBRATION_WINDOW_MS) {
    return false;
  }

  const storageKey = getStorageKey(clinicId, deployedAtTimestamp);
  return window.localStorage.getItem(storageKey) !== "true";
};

export const markWidgetDeployCelebrationSeen = (params: {
  clinicId?: string | null;
  widgetDeployedAt?: string | null;
}): void => {
  const { clinicId, widgetDeployedAt } = params;
  if (!clinicId || !widgetDeployedAt || typeof window === "undefined") return;

  const deployedAtTimestamp = parseWidgetDeployedAt(widgetDeployedAt);
  if (!deployedAtTimestamp) return;

  const storageKey = getStorageKey(clinicId, deployedAtTimestamp);
  window.localStorage.setItem(storageKey, "true");
};
